<template>
    <component
        :is="buttonComponent"
        class="button-primary"
        type="button"
        :class="buttonClasses"
        :disabled="buttonDisabled"
        v-bind="buttonUrl ? {href: buttonUrl} : {}"
        :to="buttonRoute"
        @click="buttonClick(buttonClickParams)"
    >
        {{ buttonText }}
    </component>
</template>

<script>
export default {
    name: 'ButtonPrimary',
    props: {
        buttonColor: {
            required: false,
            type: String,
            default: 'bg-sky-400 text-zinc-900 hover:bg-sky-300 focus-visible:outline-zinc-600',
        },
        buttonDisabled: {
            required: false,
            type: [Boolean, Number],
            default: false,
        },
        buttonRoute: {
            required: false,
            type: [String, Object],
            default: null,
        },
        buttonUrl: {
            required: false,
            type: String,
            default: null,
        },
        buttonText: {
            required: false,
            type: String,
            default: null,
        },
        buttonClick: {
            required: false,
            type: Function,
            default: () => {},
        },
        buttonClickParams: {
            required: false,
            type: [String, Object, Array],
            default: null,
        },
    },
    computed: {
        buttonComponent() {
            if (this.buttonUrl) return 'a';
            return this.buttonRoute ? 'router-link' : 'button';
        },
        buttonClasses() {
            const cls = {};
            cls['inline-block'] = true;
            cls['px-3 sm:px-4 py-3'] = true;
            cls['rounded-md shadow-xs'] = true;
            cls['cursor-pointer'] = true;
            cls['focus-visible:outline-solid focus-visible:outline-2 focus-visible:outline-offset-2'] = true;
            cls['sm:text-lg font-bold'] = true;
            cls[this.buttonColor] = true;
            cls['disabled:bg-zinc-500'] = !!this.buttonDisabled;
            return cls;
        },
    },
};
</script>
